import { displayStringFromFHIRCodeableConcept } from "../../datatypeComponents/CodeableConceptEntry";
import { displayStringFromFHIRQuantity } from "../../datatypeComponents/QuantityEntry";

const generateNarrativeForEvidenceResource = (resource) => {
    let status = "generated";
    let innerDiv = "";
    try {
        if (resource.title) {
            innerDiv += "<p><b>Title: </b>" + resource.title + "</p>";
        }
        if (resource.name) {
            innerDiv += "<p><b>Name: </b>" + resource.name + "</p>";
        }
        if (resource.description) {
            innerDiv += "<p><b>Description: </b>" + resource.description + "</p>";
        }
        if (resource.assertion) {
            innerDiv += "<p><b>Assertion: </b>" + resource.assertion + "</p>";
        }
        if (resource.note?.length > 0) {
            innerDiv += resource.note.map((note) => {
                return "<p><b>Note: </b>" + note.text + "</p>"
            }).join("");
        }
        if (resource.variableDefinition?.length > 0) {
            innerDiv += resource.variableDefinition.map((varDef) => {
                let varRole;
                if (typeof (varDef.variableRole) === "string") {
                    varRole = varDef.variableRole;
                } else if (varDef.variableRole.coding?.[0]?.code) {
                    varRole = varDef.variableRole.coding[0].code;
                } else {
                    varRole = displayStringFromFHIRCodeableConcept(varDef.variableRole);
                }
                let varDefDisplay = "<b>Variable in role of " + varRole + ": </b>";
                if (varDef.description) {
                    varDefDisplay += varDef.description;
                } else if (varDef.observed?.display) {
                    varDefDisplay += varDef.observed.display;
                } else if (varDef.intended?.display) {
                    varDefDisplay += varDef.intended.display;
                } else {
                    varDefDisplay += "noted";
                }
                return "<p>" + varDefDisplay + "</p>"
            }).join("");
        }
        if (resource.synthesisType) {
            innerDiv += "<p><b>Synthesis Type: </b>" + displayStringFromFHIRCodeableConcept(resource.synthesisType) + "</p>";
        }
        if (resource.studyDesign?.length > 0) {
            innerDiv += resource.studyDesign.map((item) => {
                return "<p><b>Study Design: </b>" + displayStringFromFHIRCodeableConcept(item) + "</p>"
            }).join("");
        }
        if (resource.statistic?.length > 0) {
            innerDiv += resource.statistic.map((item) => {
                if (item.description) {
                    return "<p><b>Statistic: </b>" + item.description + "</p>"
                } else if (item.statisticType && item.quantity) {
                    return "<p><b>Statistic: </b>" + displayStringFromFHIRCodeableConcept(item.statisticType) + " " + displayStringFromFHIRQuantity(item.quantity) + "</p>"
                } else {
                    return "<p><b>Statistic: </b>unclear</p>"
                }
            }).join("");
        }
        if (resource.certainty?.length > 0) {
            innerDiv += resource.certainty.map((item) => {
                let certaintyType = displayStringFromFHIRCodeableConcept(item.type) || "untyped";
                let certaintyRating = displayStringFromFHIRCodeableConcept(item.rating) || "unrated";
                return "<p><b>Certainty of type " + certaintyType + ": </b>" + certaintyRating + "</p>"
            }).join("");
        }
    } catch {
        innerDiv = "[Unable to generate Narrative Summary.]"
    }
    return { "status": status, "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\">" + innerDiv + "</div>" };
}

export default generateNarrativeForEvidenceResource;